import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store from "nexia_mobile/flux_like/store";
import { currentlyConfiguring724 } from "nexia_mobile/api/xr724";
import { currentlyConfiguringDragonfly } from "nexia_mobile/api/dragonfly";
import Environment from "nexia_mobile/environment";
import LocalSettings from "nexia_mobile/models/local_settings";

function pingUrl() {
  return `${LocalSettings.getHost()}/rack_pinger?${Date.now()}`;
}

function shouldCheck() {
  return (
    !Store.isAppPaused &&
    !Store.isPlayingVideo &&
    !currentlyConfiguring724() &&
    !currentlyConfiguringDragonfly() &&
    !Store.currentlyPollingEnrollmentStatus &&
    !Environment.isTestRunner() &&
    !(Store.appState && Store.appState.inDemoMode)
  );
}

let timeout;
function enqueueNextCheck() {
  const interval = Store.isNetworkConnected ? 10000 : 2000;
  clearTimeout(timeout); // Don't allow more than one at once, in case this is called more than once per check cycle.
  timeout = setTimeout(() => Dispatch("CHECK_NETWORK_STATUS"), interval);
}

Dispatch.on("INIT_CONNECTION_TRACKING", () => {
  Dispatch("CHECK_NETWORK_STATUS");
});

Dispatch.on("CHECK_NETWORK_STATUS", () => {
  if (!shouldCheck()) {
    enqueueNextCheck();
    return;
  }

  $.ajax(pingUrl(), {
    success() {
      if (!shouldCheck()) {
        enqueueNextCheck();
        return;
      }
      Dispatch("NETWORK_CONNECTION_UP");
      enqueueNextCheck();
    },
    error(xhr) {
      if (!shouldCheck()) {
        enqueueNextCheck();
        return;
      }
      if (xhr && xhr.statusText === "abort") {
        enqueueNextCheck();
        return;
      }
      Dispatch("NETWORK_CONNECTION_DOWN");
      enqueueNextCheck();
    },
    timeout: Store.isNetworkConnected ? 9000 : 1950,
  });
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/connection.js